<template>
<m-mobile-autocomplete
    :value="internal_value"
    :items="items"
    :search="doSearch"
    v-on:input="onInput"
    v-on:remove="onRemove"
    v-on:toggle-multiselect="toggleMultiselect"
    v-on:begin-conversation="onBeginConversation"
    :is_multiselect="is_multiselect"
    :selected_values="selected_values"
    :label="label"
    :disable_group_text="disable_group_text"
    placeholder="Search for or enter a new phone number"
    :dialog_only="dialog_only"
    ref="my-ctrl"
    :read_only="read_only"
    :action_button_text="action_button_text"
    :default_multiselect="default_multiselect"
>
    <template v-slot:default="slotProps">

        <v-list-item-action
            v-if="is_multiselect"
            style="margin-right: 10px"
        >
            <v-checkbox
                v-model="slotProps.item.is_selected"
                v-on:click="onCheckContact(slotProps.item)"
                dense
            ></v-checkbox>
        </v-list-item-action>

        <v-list-item-avatar
            style="margin-right: 10px"
        >
            <m-avatar
                v-if="slotProps.item.avatar != null"
                :avatar="slotProps.item.avatar"
                no_margin
            />
        </v-list-item-avatar>

        <v-list-item-content>{{slotProps.item.text}}</v-list-item-content>

        
        <m-phone-validation-chip
            :value="slotProps.item"
        />
        

    </template>
</m-mobile-autocomplete>
</template>

<script>
const E164 = require('@/js/E164.js');
const device = require('@/js/device.js');
const Labels = require('@/js/Labels.js');
const Avatar = require('@/js/Avatar.js');

export default {
    props: {
        value: {
            type: Object,
            default: function() { return null; },
        },
        
        label: {
            type: String,
            default: function() { return "Phone Number"; },
        },

        organization_id: {
            type: String,
            default: function() { return null; },
        },

        autofocus: {
            type: Boolean,
            default: function() { return false; },
        },

        dialog_only: {
            type: Boolean,
            default: function() { return false; },
        },

        set_from_endpoint_value: {
            type: String,
            default: function () { return null; },
        },

        disable_group_text: {
            type: Boolean,
            default: function() { return false; }
        },

        read_only: {
            type: Boolean,
            default: function() { return false; }
        },

        default_multiselect: {
            type: Boolean,
            default: function() { return false; }
        },

        action_button_text: {
            type: String,
            default: function() { return 'Begin Conversation'; }
        },
    },

    data() {
        return {
            internal_value: null,
            items: [],
            search: null,
            is_loading: false,
            is_multiselect: false,
            selected_values: [],
            raw_result: null,
        }
    },

    mounted () {
        this.internal_value = this.value;
        if ( this.value == null )
            this.doSearch('');

        // clear out any multiselects
        this.selected_values = [];

        if ( this.set_from_endpoint_value )
        {
            this.setInternallyFromRawValue(this.set_from_endpoint_value);
        }
    },

    methods: {
        onCheckContact(item) {
            
            if ( item.is_selected )
            {
                item.is_selected = false;
            }
            else
            {
                item.is_selected = true;
            }
        },

        toggleMultiselect() {
            this.is_multiselect = !this.is_multiselect;
        },

        onBeginConversation() {
            this.$emit('start-group-text', this.selected_values);
        },

        resetValues() {
            this.selected_values = [];
            this.is_multiselect = this.default_multiselect;
        },

        onInput(val) {
            if ( val.value == null )
            {
                return;
            }

            let emit_val = {
                'text' : val.text,
                'value' : val.value,
                'name' : val.name
            };

            if ( this.is_multiselect )
            {
                // make it work like a toggle. If the item is selected, deselect it
                for ( let i=0; i < this.selected_values.length; i++ )
                {
                    if ( this.selected_values[i].value == emit_val.value )
                    {
                        this.onRemove(emit_val);
                        return;
                    }
                }

                this.selected_values.push(emit_val);
                return;
            }
            else
            {
                this.$emit('input', emit_val);
                this.internal_value = val;
            }
        },

        onRemove(item) {
            this.selected_values = this.selected_values.filter(function(ele){
                return ele.value != item.value;
            });
        },

        passAllItems(item, queryText, itemText)
        {
            return true;
        },

        showPartialSendTo(val)
        {
            val = val.trim();

            if ( val.length == 0 ) return false;

            for ( let i = 0; i < val.length; i++ )
            {
                let cur_char = val.charAt(i);

                if ( cur_char === '0' || cur_char === '1' || cur_char === '2' || cur_char === '3' || cur_char === '4' || cur_char === '5' || cur_char === '6' || cur_char === '7' || cur_char === '8' || cur_char === '9' )
                    continue;

                if ( cur_char === ' ' || cur_char === '.' || cur_char === '-' )
                    continue;

                return false;
            }
            
            return true;
        },

        doSearch(val)
        {
            let items = [];

            let val_as_endpoint = E164.createEndpointFromUSPhoneNumber(val,null);

            if ( val_as_endpoint != null )
            {
                let avatar = new Avatar(val_as_endpoint, val_as_endpoint);
                avatar.forceColor('#75EABD');
                
                items.push({
                    'text' : 'Send to '+E164.prettyPrintUsPhoneNumber(val_as_endpoint),
                    'value' : val_as_endpoint,
                    'name' : null,
                    'avatar' : avatar,
                });
            }
            else if ( this.showPartialSendTo(val) )
            {
                let avatar = new Avatar('E164:+11112223333', 'E164:+11112223333');
                avatar.forceColor('#CAD0E0');
                
                 items.push({
                    'text' : 'Send to '+val,
                    'value' : val_as_endpoint,
                    'name' : null,
                    'avatar' : avatar,
                });
            }

            this.is_loading = true;

            let full_text_search = val;
            if ( val != null && val.indexOf("(") != -1 )
            {
                full_text_search = val.substring(0,val.indexOf("("));
            }


            this.$rc.searchPhoneNumbersFullText(

                { 'full_text' : full_text_search, 'organization_id': this.organization_id },

                (data) => {

                    this.is_loading = false;

                    let results = data.results;

                    let labels = this.toLabelData(results);

                    for ( let i = 0; i < results.length; i++ )
                    {
                        let label = results[i].contact_label;  // E164.prettyPrintUsPhoneNumber(results[i].endpoint) + ' - ' 
                        
                        if ( results[i].endpoint_label != null )
                            label += ' ('+results[i].endpoint_label+')';

                        
                         items.push({
                            'text' : label,
                            'value' : results[i].endpoint,
                            'name' : results[i].contact_label,
                            'avatar' : new Avatar(label, results[i].endpoint),
                            'orig_result' : results[i]
                        });
                    }

                    this.items = items;
                },

                () => {
                    this.is_loading = false;
                    this.items = items;
                }
            );
        },

       toLabelData(results)
       {
           if ( results == null ) return new Labels([]);

           let label_data = [];

           for ( let i = 0; i < results.length; i++ )
           {
               label_data.push({
                   'label' : results[i].contact_label,
                   'endpoint' : results[i].endpoint,
               });
           }

           let labels = new Labels();
           labels.upsert(label_data);
           return labels;
       },

        showDialog()
        {
            this.resetValues();
            this.$refs['my-ctrl'].showDialog();
        },

        clearInternalValue()
        {
            this.internal_value = null;
        },

        setInternallyFromRawValue(val)
        {
            if ( val == null || val == '' || this.organization_id == null || this.organization_id == '')
            {
                // do nothing, value is bad
                return;
            }

            let search = {
                'full_text' : val,
                'organization_id': this.organization_id,
            };

            this.$rc.searchPhoneNumbersFullText(
                search,
                (data) =>
                {
                    if (data.results == null || data.results.length == 0)
                    {
                        // use default Send to...
                        this.internal_value = {
                            'text' : E164.prettyPrintUsPhoneNumber(val),
                            'value' : val,
                            'name' : E164.prettyPrintUsPhoneNumber(val),
                        };
                    }
                    else
                    {
                        let label = data.results[0].contact_label == '' ?
                            E164.prettyPrintUsPhoneNumber(data.results[0].endpoint) : data.results[0].contact_label;

                        this.internal_value = {
                            'text'  : label,
                            'value' : data.results[0].endpoint,
                            'name'  : label,
                        };
                    }
                }
            );
        },

        

    },

    watch: {
        value(val) {
            if ( val == null )
            {
                this.items = null;
                this.internal_value = null;
                this.search = null;
                return;
            }

            this.items=[val];
            this.internal_value = this.items[0];
            this.search = this.internal_value.text;
        },

        set_from_endpoint_value(val) {
            this.setInternallyFromRawValue(val);
        },
    },
}

</script>

<style lang="scss" scoped>

</style>